import { component_tool, utils_tool } from '../../../tool';
let { WizModal, WizSurveyAudience, WizTypography, WizRow } = component_tool;
let { $$, checkStrLength } = utils_tool;
import { WizClassifySelect } from '../../common'
import React from 'react'
import { WizTableForm } from '../../common'
const organizationConfig = WizTableForm.Config.organization(this, { apiParams: { state: 1 , organizationNodeCategory:["2"]} })
const userConfig = WizTableForm.Config.user(this, { apiParams: { state: 1,userType:1,organizationIdList:[1141] } })

//配置项
let componentName = 'requirementNotice'

const columns = [
  {
    name: "id",
    formItem: {
      type: "hidden"
    }
  },
 
  {
    title: '省/自治区/直辖市',
    name: 'provincial',
    dict: [
      { code: '北京市', codeName: '北京市' },
      { code: '天津市', codeName: '天津市' },
      { code: '河北省', codeName: '河北省' },
      { code: '山西省', codeName: '山西省' },
      { code: '内蒙古自治区', codeName: '内蒙古自治区' },
      { code: '辽宁省', codeName: '辽宁省' },
      { code: '吉林省', codeName: '吉林省' },
      { code: '黑龙江省', codeName: '黑龙江省' },
      { code: '上海市', codeName: '上海市' },
      { code: '江苏省', codeName: '江苏省' },
      { code: '浙江省', codeName: '浙江省' },
      { code: '安徽省', codeName: '安徽省' },
      { code: '福建省', codeName: '福建省' },
      { code: '江西省', codeName: '江西省' },
      { code: '山东省', codeName: '山东省' },
      { code: '河南省', codeName: '河南省' },
      { code: '湖北省', codeName: '湖北省' },
      { code: '湖南省', codeName: '湖南省' },
      { code: '广东省', codeName: '广东省' },
      { code: '广西壮族自治区', codeName: '广西壮族自治区' },
      { code: '海南省', codeName: '海南省' },
      { code: '四川省', codeName: '四川省' },
      { code: '贵州省', codeName: '贵州省' },
      { code: '云南省', codeName: '云南省' },
      { code: '西藏自治区', codeName: '西藏自治区' },
      { code: '重庆市', codeName: '重庆市' },
      { code: '陕西省', codeName: '陕西省' },
      { code: '甘肃省', codeName: '甘肃省' },
      { code: '青海省', codeName: '青海省' },
      { code: '宁夏回族自治区', codeName: '宁夏回族自治区' },
      { code: '新疆维吾尔自治区', codeName: '新疆维吾尔自治区' },
      { code: '台湾省', codeName: '台湾省' },
      { code: '香港特别行政区', codeName: '香港特别行政区' },
      { code: '澳门特别行政区', codeName: '澳门特别行政区' },
    ],
    searchItem: {
      type: 'select',
     // mode: 'multiple',
    },
    tableItem: {width: 180},
  },
  {
    title: "别称",
    name: "anotherName",
    dataIndex: "anotherName",
    tableItem: {width: 150},

  },
  {
    title: "是否为新能源店",
    name: "isNewEnergy",
    dataIndex: "isNewEnergy",
    tableItem: {width: 150},
    dict: [
      { code: 0, codeName: '否' },
      { code: 1, codeName: '是' },
    ],
    searchItem: {
      type: 'select',
    }

  },
  {
    title: "新开业管理员",
    name: "requirementManager",
    searchItem: {
      diy: WizTableForm,
      selectType:"radio",
      ...userConfig,
    }
  },
  {
    title: "新开业管理员",
    name: "requirementManagerStr",
    dataIndex: "requirementManagerStr",
    tableItem: {width: 300},

  },
  {
    title: "状态",
    name: "state",
    dataIndex: "state",
    tableItem: {},
    dict: [
      { code: 0, codeName: "无效" },
      { code: 1, codeName: "有效" }
    ],
    searchItem: {
      type: "select"
    },
  },
];

const templateConfig = {
  mainProps: {},
  content: {
    name: "WizTableList",
    params: {
      columns,
      searchBarProps: {
        cols: {
          xs: 24,
          md: 12,
          xl: 8
        },
        collapse: false,
        buttonSort: ['add','export'],
        buttons: [
          {
            key: "add",
            custom: true,
            params: { icon: "plus", children: "新增", type: "primary"},
            customOnClick: {
              key: "jumpPage",
              params: {
                key: "push",
                pathname: "/requirementNotice/requirementNoticeList/requirementNoticeAdd"
              }
            }
          },
          {
            key: 'export',
            custom: true,
            params: {icon: 'export', children: '导出', type: 'export'},
            customOnClick: {
              key: 'action',
              params: {
                apiKey: "export",
                apiParams: {}
              },
              formatParams: (rows, record, filters, callback) => {
                return {...filters}
              }
            }
          }
        ]
      },
      modalFormProps: {},
      dataTableProps: {
        rowKey: "id",
        selectType: "checkbox",
        isScroll: true,
        loading: false,
      },
      // showAuth: {
      //   title: '适用范围',
      //   dataIndex: 'authData'
      // },
      rowOperateSort: ['update', 'emailRecord'],
      rowOperateView: [
        {
          key: "update",
          custom: true,
          params: { children: "编辑"},
          customOnClick: {
            key: "jumpPage",
            params: {
              key: "push",
              pathname: "/requirementNotice/requirementNoticeList/requirementNoticeUpd"
            }
          }
        },
        {
          key: "emailRecord",
          custom: true,
          params: { children: "邮件记录"},
          customOnClick: {
            key: "jumpPage",
            params: {
              key: "push",
              pathname: "/requirementNotice/requirementNoticeList/requirementNoticeRecordList"
            }
          }
        },

      ],
      commonOperate: {
        add: true,
        update: true
      }
    }
  }
};

const apis = {
  list: {
    path: `${componentName}/getListByPage`,
    payload: {
      key: `${componentName}@listByPage`,
      apiParams: { pageNum: 1, pageSize: 10 }
    }
  }
  ,
  // add: {
  //   path: `${componentName}/add`,
  //   payload: {
  //     key: `${componentName}@add`,
  //     apiParams: {}
  //   }
  // },
  // update: {
  //   path: `${componentName}/update`,
  //   payload: {
  //     key: `${componentName}@update`,
  //     apiParams: {}
  //   }
  // },
  // updateState: {
  //   path: `${componentName}/updateState`,
  //   payload: {
  //     key: `${componentName}@updateState`,
  //     apiParams: {}
  //   }
  // },

  export: {
    path: `${componentName}/export`,
    payload: {
      key: `${componentName}@export`,
      apiParams: { }
    }
  }

}


let reduxTemplateCofig = (args) => {
  return {
    apis,
    componentName,
    initApiKeys: ['list'],
    needLoading: true,
    ...args
  }
};

export { reduxTemplateCofig, templateConfig };
